import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { errorMessage } from "../../lib/api";

/**
 * Landing spot after Google sign-in (Emergent Auth). The URL fragment holds a one-time
 * session_id which is exchanged server-side for our own admin session cookie.
 */
const AuthCallback = () => {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    loginWithGoogleSession(sessionId)
      .then((user) => {
        toast.success(`Welcome, ${user.name || user.email}`);
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        toast.error(errorMessage(err, "Google sign-in failed"));
        navigate("/admin/login", { replace: true });
      });
  }, [location.hash, loginWithGoogleSession, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
